import { SavedPaymentForm } from 'Forms/SavedPaymentForm/SavedPaymentForm';
import { PaymentForm } from 'Forms/PaymentForm';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getCardPaymentMethodId } from 'Utils/PaymentMethods';
import { useStore } from 'Hooks/useStore';

export const CardPayment = ({
  handleCardPayment,
  handleSavedPayment,
  submitButtonText,
  trackPaymentAction,
  cardPaymentForm,
  setEnablePaymentButton,
  savedCardPaymentForm,
  setIsSubmitting,
  hasSavedPayment,
  setIsUpdateCardMode,
  setVtCheckMissing,
  setErrorMessage,
}) => {
  const [isEditCard, setEditCard] = useState(false);
  const paymentMethods = useSelector((s) => s.paymentMethods);
  const { selectedPlan } = useStore('plans');
  const { billingAddress = {} } = useStore('checkout');

  if (hasSavedPayment && !isEditCard) {
    return (
      <SavedPaymentForm
        ref={savedCardPaymentForm}
        paymentMethod={paymentMethods.cardPayment}
        selectedPlan={selectedPlan}
        billingAddress={billingAddress}
        setVtCheckMissing={setVtCheckMissing}
        setEnablePaymentButton={setEnablePaymentButton}
        onFormSubmit={() => {
          setIsSubmitting(true);
          handleSavedPayment(getCardPaymentMethodId(paymentMethods.cardPayment));
        }}
        submitButtonText={submitButtonText}
        onEditCard={() => {
          setEditCard(true);
          trackPaymentAction('edit card');
          setIsUpdateCardMode(true);
        }}
      />
    );
  }
  return (
    <PaymentForm
      ref={cardPaymentForm}
      setEnablePaymentButton={setEnablePaymentButton}
      showCancelButton={isEditCard}
      selectedPlan={selectedPlan}
      billingAddress={billingAddress}
      onFormSubmit={handleCardPayment}
      submitButtonText={submitButtonText}
      setIsSubmitting={setIsSubmitting}
      setErrorMessage={setErrorMessage}
      onCancelClick={() => {
        setEditCard(false);
        setIsUpdateCardMode(false);
        trackPaymentAction('cancel edit card');
      }}
    />
  );
};
